export const siteMeilisearchLockspaceSearchKeyKeys = {
  all: ['site-meilisearch-lockspace-search-key'] as const,
  details: () =>
    [...siteMeilisearchLockspaceSearchKeyKeys.all, 'detail'] as const,
  detail: (directoryToken: string) =>
    [
      ...siteMeilisearchLockspaceSearchKeyKeys.details(),
      directoryToken,
    ] as const,
};
